import { useEffect } from 'react';
import { useInvalidator } from 'rest-hooks';

export default function useInvalidateCacheOnUnmount(fetchShape, params) {
  const invalidate = useInvalidator(fetchShape);
  useEffect(() => {
    return () => invalidate(params);
  }, []);
}



// WEBPACK FOOTER //
// ./app/javascript/client/hooks/useInvalidateCacheOnUnmount.js